import {parseFontSize as parseFontSizeIntoParts} from '@frontapp/editor-html';
import memoize from 'lru-memoize';

/*
 * Constants.
 */

export const defaultFontSize = 14;

/*
 * Helpers.
 */

export function formatFontSize(fontSize: number): string {
  return `${fontSize}px`;
}

export const parseFontSize: (value: string) => number | undefined = memoize(10)((value: string) => {
  const parts = parseFontSizeIntoParts(value);
  return parts && parts.unit === 'px' ? parts.value : undefined;
});
